import React from "react";
import { Menu, MenuItem, IconButton, Container } from "@material-ui/core";
import { MoreVert as MenuDotIcon } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import firebase from 'firebase/app'
import { useAuth } from "../contexts/AuthContext";
import "firebase/database"
import AvatarBadge from "./AvatarBadge";

export default function DotMenu({color}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  let history = useHistory();
  const {currentUser} = useAuth()
  const dbRef = firebase.database()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSettings = () => {
    history.push("/settings")
  }

  const handleLogout = async () => {
    try {
      await dbRef.ref(`userstatus/${currentUser.uid}`).set("offline")
      await firebase.auth().signOut();
      console.log("user signed out!");
      history.push('/')
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{marginLeft: "auto", marginRight: 0}}>
      <IconButton
        style={{color: color}}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MenuDotIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem divider>
          <AvatarBadge userId={currentUser.uid} src={currentUser.photoURL} alt={currentUser.displayName}>{currentUser.displayName[0]}</AvatarBadge>
          <Container>
            Hey, {currentUser.displayName.split(" ")[0]}
          </Container>
        </MenuItem>
        <MenuItem onClick={handleSettings}>Settings</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
}
